import { $ } from '../vendors/jquery';

const utmTracking = {
    init() {
        $(window).on( 'load', function(){
            function getUTMParams() {
                const params = new URLSearchParams(window.location.search);
                
                return {
                    utm_source: params.get('utm_source') || null,
                    utm_medium: params.get('utm_medium') || null,
                    utm_campaign: params.get('utm_campaign') || null,
                    utm_content: params.get('utm_content') || null,
                    utm_term: params.get('utm_term') || null,
                    utm_gclid: params.get('gclid') || null
                };
            }

            function hasUTMParams(utmParams) {
                for (const key in utmParams) {
                    if (utmParams[key] !== null) {
                        return true;
                    }
                }
                
                return false;
            }

            // Find and split campaign name cookie
            function readCookie(name) {
                const nameEQ = name + '=';
                const ca = document.cookie.split(';');
                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (' ' === c.charAt(0)) c = c.substring(1, c.length);
                    if (0 === c.indexOf(nameEQ)) return c.substring(nameEQ.length, c.length);
                }
                
return null;
            }


            // Create cookie function
            function setCookie(cname, cvalue, exdays, path) {
                const d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                const expires = 'expires=' + d.toGMTString();
                document.cookie = cname + '=' + cvalue + '; ' + expires + ';domain=.peco-inspx.com;' + 'path=' + path;
            }

            const utmParams = getUTMParams();
            const utmExist = hasUTMParams(utmParams);
            const conversionPage = window.location.origin + window.location.pathname + window.location.search + window.location.hash;
            const landingPage = window.location.origin + window.location.pathname + window.location.search + window.location.hash;
            let utmCookiesExist = false;

            if( readCookie('utm_source') !== null
                || readCookie('utm_medium') !== null
                || readCookie('utm_campaign') !== null
                || readCookie('utm_content') !== null
                || readCookie('utm_term') !== null
                || readCookie('utm_gclid') !== null ) {
                utmCookiesExist = true;
            }

            if(false === utmCookiesExist) {
                if (null === readCookie('utm_source') && utmParams.utm_source !== null) {
                    setCookie('utm_source', utmParams.utm_source, 1, '/');
                }
                if (null === readCookie('utm_medium') && utmParams.utm_medium !== null) {
                    setCookie('utm_medium', utmParams.utm_medium, 1, '/');
                }
                if (null === readCookie('utm_campaign') && utmParams.utm_campaign !== null) {
                    setCookie('utm_campaign', utmParams.utm_campaign, 1, '/');
                }
                if (null === readCookie('utm_content') && utmParams.utm_content !== null) {
                    setCookie('utm_content', utmParams.utm_content, 1, '/');
                }
                if (null === readCookie('utm_term') && utmParams.utm_term !== null) {
                    setCookie('utm_term', utmParams.utm_term, 1, '/');
                }
                if (null === readCookie('utm_gclid') && utmParams.utm_gclid !== null) {
                    setCookie('utm_gclid', utmParams.utm_gclid, 1, '/');
                }
            }

            if (false === utmCookiesExist && utmExist){
                setCookie('utm_landing_page', landingPage, 1, '/');
            } else if (null === readCookie('utm_landing_page')) {
                setCookie('utm_landing_page', landingPage, 1, '/');
            }

            setTimeout(function () {
                // Add cookie info to hidden fields for web to lead fields
                if( readCookie('utm_source') !== null ) {
                    $('.gform_wrapper .utm_source input').val(readCookie('utm_source'));
                }
                if( readCookie('utm_medium') !== null ) {
                    $('.gform_wrapper .utm_medium input').val(readCookie('utm_medium'));
                }
                if( readCookie('utm_campaign') !== null ) {
                    $('.gform_wrapper .utm_campaign input').val(readCookie('utm_campaign'));
                }
                if( readCookie('utm_content') !== null ) {
                    $('.gform_wrapper .utm_content input').val(readCookie('utm_content'));
                }
                if( readCookie('utm_gclid') !== null ) {
                    $('.gform_wrapper .utm_gclid input').val(readCookie('utm_gclid'));
                }
                if( readCookie('utm_landing_page') !== null ) {
                    $('.gform_wrapper .utm_landing_page input').val(readCookie('utm_landing_page'));
                }

                $('.gform_wrapper .utm_conversion_page input').val(conversionPage);
            }, 2000); // The 2 seconds delay from the beginning
        });
    }
};

export default utmTracking;
